import { motion } from 'framer-motion';
import { ArrowRight, MessageSquare } from 'lucide-react';

export const FooterCTA = () => {
  return (
    <section className="py-24 lg:py-32" data-testid="footer-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          {/* Background Glow */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#25D366]/20 to-emerald-500/20 rounded-3xl blur-3xl" />
          
          <div className="relative bg-gradient-to-br from-slate-900 to-slate-800 dark:from-slate-800 dark:to-slate-900 rounded-3xl p-8 lg:p-16 overflow-hidden">
            {/* Pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }} />
            </div>

            <div className="relative text-center max-w-3xl mx-auto">
              {/* Icon */}
              <motion.div
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#25D366] mb-8"
              >
                <MessageSquare className="w-8 h-8 text-white" />
              </motion.div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                Your most productive workday
                <br />
                <span className="text-[#25D366]">starts with one message.</span>
              </h2>

              <p className="text-lg text-slate-400 mb-10 max-w-xl mx-auto">
                Join 2,000+ Indian professionals who've already made AssistlyAI their secret productivity weapon. 
                Start your free trial today.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://wa.me/919981361957?text=Hi%20AssistlyAI!"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-green-500/30"
                  data-testid="footer-cta-primary"
                >
                  Add AssistlyAI to WhatsApp
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </a>
              </div>

              {/* Trust Line */}
              <div className="flex flex-wrap items-center justify-center gap-4 mt-8 text-sm text-slate-500">
                <span>14-day free trial</span>
                <span className="w-1 h-1 bg-slate-600 rounded-full" />
                <span>No credit card required</span>
                <span className="w-1 h-1 bg-slate-600 rounded-full" />
                <span>Cancel anytime</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
